var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('img',{staticStyle:{"display":"none"},attrs:{"height":"1","width":"1","src":_vm.pix_api_url}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }